import React, { useState, useEffect, useContext } from "react";

const FontListContext = React.createContext();

const FontListContextProvider = ({ children }) => {
  const [cartFontList, setCartFontList] = useState([]);
  const [mainFontList, setMainFontList] = useState([]);
  const [sampleList, setSampleList] = useState([]);

  useEffect(() => { });

  const saveMainFontList = (list) => {
    setMainFontList(list);
  };

  const clearCartFontList = () => {
    setCartFontList([]);
  };

  //카트에 폰트를 추가하는
  const addCartFontList = (font) => {
    const list = cartFontList.filter((f) => font.idx !== f.idx);
    const item = {
      ...font,
      isSelect: false,
      fontList: font.fonts.split(","),
    };
    setCartFontList([...list, item]);
  };

  const selectCartFontList = (idx) => {
    setCartFontList(
      cartFontList.filter((f) => {
        if (parseInt(idx, 10) === f.idx) {
          f.isSelect = !f.isSelect;
        }
        return f;
      })
    );
  };

  const removeCartFontFamily = (idx) => {
    setCartFontList(cartFontList.filter((f) => parseInt(idx, 10) !== f.idx));
  };

  const removeCartFont = (name) => {
    setCartFontList(
      cartFontList.filter((f) => {
        f.fontList = f.fontList.filter((f) => f !== name);
        if (f.fontList.length !== 0) {
          return f;
        }
        return null;
      })
    );
  };

  return (
    <FontListContext.Provider
      value={{
        mainList: { mainFontList },
        mainFn: { saveMainFontList },
        list: { cartFontList },
        sample: { sampleList },
        fn: {
          addCartFontList,
          clearCartFontList,
          removeCartFontFamily,
          selectCartFontList,
          removeCartFont,
        },
      }}
    >
      {children}
    </FontListContext.Provider>
  );
};

export const useFontCartList = () => {
  const { list } = useContext(FontListContext);
  return list;
};

export const useFontList = () => {
  const { mainList } = useContext(FontListContext);
  return mainList;
};

export const useFontCartUpdate = () => {
  const { fn } = useContext(FontListContext);
  return fn;
};

export const useFontListUpdate = () => {
  const { mainFn } = useContext(FontListContext);
  return mainFn;
};

export default FontListContextProvider;
